// src/services/usersService.js
import api from '@/utils/axios';

/**
 * Get current user with roles and permissions from DB (source of truth for UI).
 * Use after login and on app load to populate store.
 */
export const getMe = async (token) => {
  const response = await api.post('users/me', { token });
  if (!response.data || !response.data.success) {
    throw new Error(response.data?.error?.message || response.data?.message || 'Failed to load user');
  }
  return response.data.data;
};

/**
 * Save current user's display timezone (IANA).
 * @param {string} token
 * @param {string} timezone
 */
export const updateUserTimezone = async (token, timezone) => {
  const response = await api.post('users/me', {
    token,
    action: 'updateTimezone',
    timezone
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || response.data?.message || 'Failed to save timezone');
  }
  return response.data.data;
};

export const fetchUsers = async ({ page = 1, limit = 10, token, search }) => {
    try {
        const response = await api.post('users/manage', {
            token: token,
            action: 'listUsers',
            page,
            limit,
            search
        });

        if (response.data.success) {
            return {
                users: response.data.data.map(user => ({
                    id: user.id,
                    uName: user.name,
                    uEmail: user.email,
                    uPhone: user.phone || '',
                    uStatus: user.status == '1' || user.status == 1,
                    departmentId: user.department_id,
                    departmentName: user.department_name,
                    departmentTagColor: user.department_tag_color ?? null,
                    departmentTagTextColor: user.department_tag_text_color ?? null,
                    roles: Array.isArray(user.roles) ? user.roles : [],
                    created_at: user.created_at,
                    updated_at: user.updated_at
                })),
                total: response.data.data.length
            };
        }
        throw new Error(response.data.message || 'Failed to fetch users');
    } catch (error) {
        throw error;
    }
};

export const updateUserStatus = async ({ token, userID, status }) => {
    try {
        // Создаем объект запроса в соответствии с требованиями API
        const requestData = {
            action: 'updateUserStatus',
            token: token, // передаем токен напрямую как строку
            userID,
            status
        };

        const response = await api.post('users/manage', requestData);

        if (!response.data.success) {
            throw new Error(response.data.message || 'Failed to update user status');
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteUser = async ({ userID, token }) => {
    try {
        const response = await api.post('users/manage', {
            action: 'deleteUser',
            token: token,
            userID,
        });

        if (!response.data.success) {
            throw new Error(response.data.message || 'Failed to delete user');
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchRoles = async ({ token, departmentId = null }) => {
    try {
        const payload = { token };
        // Always include department_id in payload (even if null) so backend can determine context
        // Backend will handle null appropriately based on user permissions
        payload.department_id = departmentId;
        const response = await api.post('common/getRoles', payload);
        if (response.data.success) {
            return response.data.data || [];
        }
        throw new Error(response.data.message || 'Failed to fetch roles');
    } catch (error) {
        throw error;
    }
};
